<script setup lang="ts">
import { ref } from 'vue'
import { FilterField, TableField } from "../../components/table/table";
import { Permission } from '../../types/auth'
import ListTemplate from "../../components/ui/common/ListTemplate.vue";

withDefaults(defineProps<{
  showHeader?: boolean,
  showQuickTour?: boolean,
  showTitle?: boolean,
  showNextButton?: boolean
  perm?: Permission[]
}>(), {
  showHeader: true,
  showQuickTour: true,
  showTitle: true
})

const endPoint = '/clients/system/company/report-manager/'
const title = 'Reports'
const selectedData = ref<any | null>(null)
const showForm = ref(false)
const formMode = ref<'create' | 'edit' | 'view' | 'showQuickView' | 'toggleStatus'>('view')
const refreshData = ref(false)

const fields: TableField[] = [
  { name: 'name', caption: 'Name', sortable: true, fieldType: 'text' },
  { name: 'status', caption: 'Status', sortable: false, fieldType: 'text' },
]

const filterFields: FilterField[] = [
  {
    name: 'active',
    label: 'Status',
    type: 'select',
    value: '',
     options: [
      { id: "1", name: "Active" },
      { id: "0", name: "Inactive" },
    ],
  },
]

const permissions = ref<Permission[]>()

const changeMode = (
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
) => {
  formMode.value = mode;
  showForm.value = mode === "view" || mode === "edit" || mode === "create";
};

//const showExchangeRateForm = ref(false)
const handleActions = (action: string, data: any) => {
  console.log('action', action, data)
  if (action == 'view') {
    // Navigate to the report details page
    window.location.href = `/reports/designer/${data.uid}`
  }
}
const handleData = (data : any) => {
  selectedData.value = data
}
</script>

<template>
  <ListTemplate :endPoint = "endPoint" :title = "title" :fields = "fields" :actions = "[]" :filterFields ="filterFields"
  :tabList = "[]" :refreshData = "refreshData" @mode="changeMode" @show="showForm = true" :showForm="showForm" @permissions="permissions = $event"
  @data="handleData" :show-header="showHeader" :show-quick-tour="showQuickTour" :show-title="showTitle" :show-next-button="showNextButton"
  @custom="handleActions">
  <template #form-view>
  </template>
  
  </ListTemplate>
</template>